import ProjectModel from 'models/ProjectModel'
import IntellectualPropertyModel from 'models/IntellectualPropertyModel'
import CompanyModel from 'models/CompanyModel'
import ResourceModel from 'models/ResourceModel'

export function projectSubmodelFromJS (project) {
  switch (project.projecttype.name) {
    case 'Intellectual Property':
      return new IntellectualPropertyModel(project)
    case 'Companies':
      return new CompanyModel(project)
    default:
      return new ProjectModel(project)
  }
}

export function modelFromJS (generic) {
  if ('projecttype_id' in generic) {
    return projectSubmodelFromJS(generic)
  }
  if ('sub_category_id' in generic) {
    return new ResourceModel(generic)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/models.js